import { TFunction } from "i18next";
import { PageBlockDto } from "~/modules/pageBlocks/dtos/PageBlockDto";
import { defaultFooter } from "../defaultFooter";
import { defaultHeader } from "../defaultHeader";
import { Colors } from "~/application/enums/shared/Colors";

export function defaultLandingPage({ t }: { t: TFunction }) {
  const blocks: PageBlockDto[] = [
    // {
    //   banner: {
    //     style: "top",
    //     text: "Embed Chatbot Widgets 🎉",
    //     textMd: "You can now embed your chatbot on your website 🎉",
    //     cta: [
    //       {
    //         text: "Watch demo",
    //         href: "https://www.youtube.com/watch?v=McOYNQPPveY",
    //         target: "_blank",
    //       },
    //     ],
    //   },
    // },
    { header: defaultHeader({ t }) },
    {
      hero: {
        style: "rightImage",
        headline: t("front.hero.headline1"),
        description: t("front.hero.headline2"),
        // image: "https://cdn-images-1.medium.com/max/1600/1*5Ypr21Xnh9w3JcQzE-Na6g.png",
        // video: "https://www.youtube.com/embed/kO_dkR2lMyE?si=IKJV3b5bxsJpMUlJ",
        cta: [
          {
            text: t("front.hero.cta"),
            href: "/pricing",
            isPrimary: true,
          },
          {
            text: t("front.hero.introduction"),
            isPrimary: false,
            href: "/chat-with",
            // tour: {
            //   type: "storylane",
            //   url: "https://app.storylane.io/demo/q5hpae4vmpo7",
            // },
          },
        ],
        // topText: {
        //   text: t("front.hero.subheadline1"),
        // },
        // bottomText: {
        //   link: {
        //     text: t("front.hero.hint"),
        //     href: "/changelog",
        //   },
        // },
      },
    },
    // {
    //   layout: { css: "-mt-40" },
    //   features: {
    //     style: "cards",
    //     position: "left",
    //     topText: "",
    //     // headline: "Data Sources",
    //     // subheadline: "Explore the different data sources you can use to train GPT.",
    //     grid: {
    //       columns: "3",
    //     },
    //     items: DataSourceTypes.filter((f) => f.demoSlug && !f.disabled).map((f) => ({
    //       // image: f.icon,
    //       dataSourceType: f.value,
    //       name: t(`datalang.dataSourceTypes.${f.value}`),
    //       description: t(`datalang.demos.${f.value}.description`),
    //       link: { text: "Learn more", href: `/chat-with/${f.demoSlug}` },
    //     })),
    //   },
    // },
    // Features
    {
      layout: { css: "py-10" },
      features: {
        style: "hoverEffect",
        position: "left",
        topText: "",
        headline: "Share your Chatbot",
        subheadline: "DataLang makes it easy to share your chatbot in 4 different ways.",
        color: Colors.RED,
        className: "bg-emerald-500/30 dark:bg-emerald-500/90 dark:text-white",
        grid: {
          columns: "4",
        },
        items: [
          {
            name: "Public URL",
            description: "Share your chatbot with a public URL.",
            // img: `<svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="50" height="50" viewBox="0 0 50 50">     <path d="M 25.001953 0 C 12.439953 -1.1842379e-15 4 4.6530469 4 8.9980469 C 4 13.345047 12.439953 18 25.001953 18 C 37.562953 18 46 13.345047 46 8.9980469 C 46 4.6530469 37.562953 0 25.001953 0 z M 4 13.609375 L 4 19.150391 C 4 23.424391 12.439953 28 25.001953 28 C 37.562953 28 46 23.424391 46 19.150391 L 46 13.609375 C 42.328 17.363375 34.412953 20 25.001953 20 C 15.588953 20 7.673 17.362375 4 13.609375 z M 4 23.910156 L 4 29.195312 C 4 33.468312 12.439953 38 25.001953 38 C 37.562953 38 46 33.467313 46 29.195312 L 46 23.910156 C 42.328 27.662156 34.412953 30 25.001953 30 C 15.588953 30 7.673 27.662156 4 23.910156 z M 4 33.955078 L 4 39.150391 C 4 43.423391 12.439953 48 25.001953 48 C 37.562953 48 46 43.423391 46 39.150391 L 46 33.955078 C 42.328 37.708078 34.412953 40 25.001953 40 C 15.588953 40 7.673 37.708078 4 33.955078 z"></path> </svg>`,
          },
          {
            name: "Chatbot Widget",
            description: "Embed your chatbot on your website.",
            // img: `<svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="50" height="50" viewBox="0 0 50 50">     <path d="M 25.001953 0 C 12.439953 -1.1842379e-15 4 4.6530469 4 8.9980469 C 4 13.345047 12.439953 18 25.001953 18 C 37.562953 18 46 13.345047 46 8.9980469 C 46 4.6530469 37.562953 0 25.001953 0 z M 4 13.609375 L 4 19.150391 C 4 23.424391 12.439953 28 25.001953 28 C 37.562953 28 46 23.424391 46 19.150391 L 46 13.609375 C 42.328 17.363375 34.412953 20 25.001953 20 C 15.588953 20 7.673 17.362375 4 13.609375 z M 4 23.910156 L 4 29.195312 C 4 33.468312 12.439953 38 25.001953 38 C 37.562953 38 46 33.467313 46 29.195312 L 46 23.910156 C 42.328 27.662156 34.412953 30 25.001953 30 C 15.588953 30 7.673 27.662156 4 23.910156 z M 4 33.955078 L 4 39.150391 C 4 43.423391 12.439953 48 25.001953 48 C 37.562953 48 46 43.423391 46 39.150391 L 46 33.955078 C 42.328 37.708078 34.412953 40 25.001953 40 C 15.588953 40 7.673 37.708078 4 33.955078 z"></path> </svg>`,
          },
          {
            name: "GPT Store",
            description: "Publish your GPT to the GPT Store.",
            // img: `<svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="50" height="50" viewBox="0 0 50 50"> <path d="M 25 4 C 12.328125 4 2 12.878906 2 23.992188 C 2 30.445313 5.53125 36.0625 10.960938 39.730469 C 10.953125 39.945313 10.96875 40.296875 10.683594 41.34375 C 10.335938 42.644531 9.625 44.472656 8.1875 46.535156 L 7.164063 48 L 8.949219 48 C 15.140625 48 18.722656 43.964844 19.277344 43.316406 C 21.121094 43.75 23.019531 43.988281 25 43.988281 C 37.671875 43.988281 48 35.109375 48 23.992188 C 48 12.878906 37.671875 4 25 4 Z M 26 34.199219 L 23.300781 34.199219 L 23.300781 31.300781 L 26 31.300781 Z M 30.5 21.601563 C 30.101563 22.199219 29.300781 23.101563 28 24.300781 C 27.101563 25.199219 26.5 25.898438 26.199219 26.5 C 25.898438 27 25.800781 27.800781 25.800781 29 L 23.300781 29 C 23.300781 27.699219 23.5 26.601563 23.800781 25.800781 C 24.101563 25 24.800781 24.101563 25.898438 23 L 27 21.898438 C 27.300781 21.601563 27.601563 21.300781 27.800781 20.898438 C 28.199219 20.300781 28.398438 19.699219 28.398438 19 C 28.398438 18.101563 28.101563 17.300781 27.601563 16.699219 C 27.101563 16 26.101563 15.699219 24.898438 15.699219 C 23.300781 15.699219 22.199219 16.300781 21.601563 17.398438 C 21.300781 18 21.101563 19 21 20.101563 L 18.5 20.101563 C 18.601563 18.199219 19.101563 16.601563 20.300781 15.398438 C 21.398438 14.199219 23 13.601563 25 13.601563 C 26.800781 13.601563 28.300781 14.101563 29.398438 15.199219 C 30.5 16.199219 31.101563 17.601563 31.101563 19.199219 C 31.101563 20.199219 30.898438 21 30.5 21.601563 Z"></path> </svg>`,
          },
          {
            name: "API",
            description: "Ask questions via API.",
            // img: `<svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="50" height="50" viewBox="0 0 50 50">     <path d="M25,3.07C12.356,3.07,2.07,12.011,2.07,23c0,6.176,3.338,12.045,8.957,15.805c-0.126,1.034-0.646,3.622-2.787,6.66 c-0.199,0.283-0.225,0.653-0.066,0.961c0.159,0.308,0.476,0.502,0.822,0.504c0.02,0,0.038,0,0.059,0 c5.448-0.001,9.115-3.367,10.283-4.611c1.843,0.405,3.744,0.611,5.662,0.611c12.644,0,22.93-8.94,22.93-19.93S37.644,3.07,25,3.07z M14,16h22c0.552,0,1,0.447,1,1s-0.448,1-1,1H14c-0.552,0-1-0.447-1-1S13.448,16,14,16z M10,24c-0.552,0-1-0.447-1-1s0.448-1,1-1h17 c0.552,0,1,0.447,1,1s-0.448,1-1,1H10z M36,30H14c-0.552,0-1-0.447-1-1s0.448-1,1-1h22c0.552,0,1,0.447,1,1S36.552,30,36,30z M40,24 h-7c-0.552,0-1-0.447-1-1s0.448-1,1-1h7c0.552,0,1,0.447,1,1S40.552,24,40,24z"></path> </svg>`,
          },
        ],
      },
    },
    {
      layout: { css: "py-10 pb-20" },
      features: {
        style: "hoverEffect",
        position: "left",
        topText: "",
        headline: "Four simple steps",
        subheadline: "Data insights just got a whole lot easier. Follow these three simple four and let DataLang do the heavy lifting.",
        color: Colors.ROSE,
        className: "bg-violet-500/10 dark:bg-violet-500/90 dark:text-white",
        grid: {
          columns: "2",
        },
        items: [
          // {
          //   name: "Remix v2",
          //   description: "Focused on web standards and modern web app UX.",
          //   link: { text: t("shared.readDocs"), href: "https://remix.run/docs/en/main?ref=saasrock.com", target: "_blank" },
          // },
          // {
          //   name: "React v18",
          //   description: "A JavaScript library for building user interfaces.",
          //   link: { text: t("shared.readDocs"), href: "https://react.dev/?ref=saasrock.com", target: "_blank" },
          // },
          // {
          //   name: "Tailwind CSS v3",
          //   description: "The best utility-first CSS framework.",
          //   link: { text: t("shared.readDocs"), href: "https://tailwindcss.com/docs/utility-first?ref=saasrock.com", target: "_blank" },
          // },
          // {
          //   name: "Vite v5",
          //   description: "Next Generation Frontend Tooling.",
          //   link: { text: t("shared.readDocs"), href: "https://vitejs.dev/guide/?ref=saasrock.com", target: "_blank" },
          // },
          // {
          //   name: "Prisma v5",
          //   description: "Next-generation Node.js and TypeScript ORM.",
          //   link: { text: t("shared.readDocs"), href: "https://www.prisma.io/docs?ref=saasrock.com", target: "_blank" },
          // },
          // {
          //   name: "Stripe",
          //   description: "The best payment processor out there.",
          //   link: { text: t("shared.readDocs"), href: "https://stripe.com/docs?ref=saasrock.com", target: "_blank" },
          // },
          // {
          //   name: "Postmark",
          //   description: "Email delivery for web apps, done right.",
          //   link: { text: t("shared.readDocs"), href: "https://postmarkapp.com/support?ref=saasrock.com", target: "_blank" },
          // },
          // {
          //   name: "Novu",
          //   description: "The open-source notification infrastructure",
          //   // link: { text: t("shared.readDocs"), href: "https://novu.co//support?ref=saasrock.com", target: "_blank" },
          // },
          {
            name: "1. Set up your Data Source",
            description: "Configure your sources (Databases, Files, Text...)",
            // img: `<svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="50" height="50" viewBox="0 0 50 50">     <path d="M 25.001953 0 C 12.439953 -1.1842379e-15 4 4.6530469 4 8.9980469 C 4 13.345047 12.439953 18 25.001953 18 C 37.562953 18 46 13.345047 46 8.9980469 C 46 4.6530469 37.562953 0 25.001953 0 z M 4 13.609375 L 4 19.150391 C 4 23.424391 12.439953 28 25.001953 28 C 37.562953 28 46 23.424391 46 19.150391 L 46 13.609375 C 42.328 17.363375 34.412953 20 25.001953 20 C 15.588953 20 7.673 17.362375 4 13.609375 z M 4 23.910156 L 4 29.195312 C 4 33.468312 12.439953 38 25.001953 38 C 37.562953 38 46 33.467313 46 29.195312 L 46 23.910156 C 42.328 27.662156 34.412953 30 25.001953 30 C 15.588953 30 7.673 27.662156 4 23.910156 z M 4 33.955078 L 4 39.150391 C 4 43.423391 12.439953 48 25.001953 48 C 37.562953 48 46 43.423391 46 39.150391 L 46 33.955078 C 42.328 37.708078 34.412953 40 25.001953 40 C 15.588953 40 7.673 37.708078 4 33.955078 z"></path> </svg>`,
          },
          {
            name: "2. Add a Data View",
            description: "Expose data from a specific source.",
            // img: `<svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="50" height="50" viewBox="0 0 50 50">     <path d="M 25.001953 0 C 12.439953 -1.1842379e-15 4 4.6530469 4 8.9980469 C 4 13.345047 12.439953 18 25.001953 18 C 37.562953 18 46 13.345047 46 8.9980469 C 46 4.6530469 37.562953 0 25.001953 0 z M 4 13.609375 L 4 19.150391 C 4 23.424391 12.439953 28 25.001953 28 C 37.562953 28 46 23.424391 46 19.150391 L 46 13.609375 C 42.328 17.363375 34.412953 20 25.001953 20 C 15.588953 20 7.673 17.362375 4 13.609375 z M 4 23.910156 L 4 29.195312 C 4 33.468312 12.439953 38 25.001953 38 C 37.562953 38 46 33.467313 46 29.195312 L 46 23.910156 C 42.328 27.662156 34.412953 30 25.001953 30 C 15.588953 30 7.673 27.662156 4 23.910156 z M 4 33.955078 L 4 39.150391 C 4 43.423391 12.439953 48 25.001953 48 C 37.562953 48 46 43.423391 46 39.150391 L 46 33.955078 C 42.328 37.708078 34.412953 40 25.001953 40 C 15.588953 40 7.673 37.708078 4 33.955078 z"></path> </svg>`,
          },
          {
            name: "3. Chat with your data",
            description: "Select the data sources to train GPT with.",
            // img: `<svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="50" height="50" viewBox="0 0 50 50"> <path d="M 25 4 C 12.328125 4 2 12.878906 2 23.992188 C 2 30.445313 5.53125 36.0625 10.960938 39.730469 C 10.953125 39.945313 10.96875 40.296875 10.683594 41.34375 C 10.335938 42.644531 9.625 44.472656 8.1875 46.535156 L 7.164063 48 L 8.949219 48 C 15.140625 48 18.722656 43.964844 19.277344 43.316406 C 21.121094 43.75 23.019531 43.988281 25 43.988281 C 37.671875 43.988281 48 35.109375 48 23.992188 C 48 12.878906 37.671875 4 25 4 Z M 26 34.199219 L 23.300781 34.199219 L 23.300781 31.300781 L 26 31.300781 Z M 30.5 21.601563 C 30.101563 22.199219 29.300781 23.101563 28 24.300781 C 27.101563 25.199219 26.5 25.898438 26.199219 26.5 C 25.898438 27 25.800781 27.800781 25.800781 29 L 23.300781 29 C 23.300781 27.699219 23.5 26.601563 23.800781 25.800781 C 24.101563 25 24.800781 24.101563 25.898438 23 L 27 21.898438 C 27.300781 21.601563 27.601563 21.300781 27.800781 20.898438 C 28.199219 20.300781 28.398438 19.699219 28.398438 19 C 28.398438 18.101563 28.101563 17.300781 27.601563 16.699219 C 27.101563 16 26.101563 15.699219 24.898438 15.699219 C 23.300781 15.699219 22.199219 16.300781 21.601563 17.398438 C 21.300781 18 21.101563 19 21 20.101563 L 18.5 20.101563 C 18.601563 18.199219 19.101563 16.601563 20.300781 15.398438 C 21.398438 14.199219 23 13.601563 25 13.601563 C 26.800781 13.601563 28.300781 14.101563 29.398438 15.199219 C 30.5 16.199219 31.101563 17.601563 31.101563 19.199219 C 31.101563 20.199219 30.898438 21 30.5 21.601563 Z"></path> </svg>`,
          },
          {
            name: "4. Share it!",
            description: "Public URL, embed on your website, or publish to the GPT Store.",
            // img: `<svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="50" height="50" viewBox="0 0 50 50">     <path d="M25,3.07C12.356,3.07,2.07,12.011,2.07,23c0,6.176,3.338,12.045,8.957,15.805c-0.126,1.034-0.646,3.622-2.787,6.66 c-0.199,0.283-0.225,0.653-0.066,0.961c0.159,0.308,0.476,0.502,0.822,0.504c0.02,0,0.038,0,0.059,0 c5.448-0.001,9.115-3.367,10.283-4.611c1.843,0.405,3.744,0.611,5.662,0.611c12.644,0,22.93-8.94,22.93-19.93S37.644,3.07,25,3.07z M14,16h22c0.552,0,1,0.447,1,1s-0.448,1-1,1H14c-0.552,0-1-0.447-1-1S13.448,16,14,16z M10,24c-0.552,0-1-0.447-1-1s0.448-1,1-1h17 c0.552,0,1,0.447,1,1s-0.448,1-1,1H10z M36,30H14c-0.552,0-1-0.447-1-1s0.448-1,1-1h22c0.552,0,1,0.447,1,1S36.552,30,36,30z M40,24 h-7c-0.552,0-1-0.447-1-1s0.448-1,1-1h7c0.552,0,1,0.447,1,1S40.552,24,40,24z"></path> </svg>`,
          },
        ],
      },
    },
    {
      layout: {
        padding: { y: "py-12" },
      },
      pricing: {
        style: "simple",
        headline: t("front.pricing.title"),
        subheadline: t("front.pricing.headline"),
        position: "center",
      },
    },
    {
      layout: {
        // css: "-mt-12",
      },
      gallery: {
        style: "carousel",
        headline: "DataLang in Action",
        subheadline: "See how DataLang can help you build your next project.",
        items: [
          {
            type: "video",
            src: "https://www.youtube.com/embed/McOYNQPPveY?si=j2PGDW_IBuCZD-Dz",
            title: "DataLang Demo",
          },
          {
            type: "image",
            src: "https://cdn-images-1.medium.com/max/1600/1*tCBU0e3-mInrX3_23mex5A.png",
            title: "Create a Data View",
          },
          {
            type: "image",
            src: "https://cdn-images-1.medium.com/max/1600/1*5Ypr21Xnh9w3JcQzE-Na6g.png",
            title: "Chat with your Database",
          },
          // {
          //   type: "image",
          //   src: "https://cdn-images-1.medium.com/max/1600/1*QVkVGbFKwj8Q4PfhKI5ILQ.png",
          //   title: "Database to API",
          // },
          {
            type: "image",
            src: "https://cdn-images-1.medium.com/max/1600/1*gEVswwb5JneJ03ti5HQjwQ.png",
            title: "Create a GPT",
          },
          {
            type: "image",
            src: "https://cdn-images-1.medium.com/max/1600/1*2nKBcHSyd_mvNBaxv7rQNw.png",
            title: "Chat with your custom GPT",
          },
        ],
      },
    },
    // // Logo Clouds
    // {
    //   logoClouds: {
    //     style: "custom",
    //     headline: t("front.logoClouds.title"),
    //     logos: [
    //       {
    //         alt: "Remix",
    //         href: "https://remix.run/ref=saasrock.com",
    //         src: "https://saasrock.com/build/_assets/remix-4ESNCVZ5.png",
    //         srcDark: "https://saasrock.com/build/_assets/remix-dark-U2ASPSOI.png",
    //       },
    //       {
    //         alt: "Tailwind CSS",
    //         href: "https://tailwindcss.com/ref=saasrock.com",
    //         src: "https://saasrock.com/build/_assets/tailwindcss-G3OQBAVI.png",
    //       },
    //       {
    //         alt: "Prisma",
    //         href: "https://prisma.io/ref=saasrock.com",
    //         src: "https://saasrock.com/build/_assets/prisma-ATY77GXX.png",
    //         srcDark: "https://saasrock.com/build/_assets/prisma-dark-3FBYDJ4J.png",
    //       },
    //     ],
    //   },
    // },
    // {
    //   features: {
    //     style: "cards",
    //     position: "left",
    //     topText: "",
    //     headline: "Smart, Real-Time Chats",
    //     subheadline: "Expose a specific set of data (using SQL) to train GPT, and then chat with it in natural language.",
    //     grid: {
    //       columns: "3",
    //     },
    //     items: [
    //       {
    //         name: "Database to API",
    //         description: "Automatically make your SQL views available via API.",
    //         img: `<svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="64" height="64" viewBox="0 0 128 128"> <path d="M 14 1 C 6.8 1 1 6.8 1 14 L 1 24 L 1 28 C 1 29.7 2.3 31 4 31 L 124 31 C 125.7 31 127 29.7 127 28 L 127 14 C 127 6.8 121.2 1 114 1 L 14 1 z M 18 13 L 22 13 C 23.7 13 25 14.3 25 16 C 25 17.7 23.7 19 22 19 L 18 19 C 16.3 19 15 17.7 15 16 C 15 14.3 16.3 13 18 13 z M 34 13 L 38 13 C 39.7 13 41 14.3 41 16 C 41 17.7 39.7 19 38 19 L 34 19 C 32.3 19 31 17.7 31 16 C 31 14.3 32.3 13 34 13 z M 76 13 L 110 13 C 111.7 13 113 14.3 113 16 C 113 17.7 111.7 19 110 19 L 76 19 C 74.3 19 73 17.7 73 16 C 73 14.3 74.3 13 76 13 z M 4 37 C 2.3 37 1 38.3 1 40 L 1 114 C 1 121.2 6.8 127 14 127 L 114 127 C 121.2 127 127 121.2 127 114 L 127 40 C 127 38.3 125.7 37 124 37 L 4 37 z M 44.099609 61 C 46.699609 61 48.9 62.699219 49.5 65.199219 L 57 95.300781 C 57.3 96.900781 56.299219 98.500391 54.699219 98.900391 C 54.499219 99.000391 54.2 99 54 99 C 52.7 99 51.399609 98.099219 51.099609 96.699219 L 49.699219 91 L 39 91 C 38.8 91 38.600391 91.000391 38.400391 90.900391 L 37 96.699219 C 36.6 98.299219 35.000391 99.300391 33.400391 98.900391 C 31.800391 98.500391 30.799219 96.900781 31.199219 95.300781 L 38.699219 65.199219 C 39.299219 62.699219 41.499609 61 44.099609 61 z M 65 61 L 72.5 61 C 79.9 61 86 67.1 86 74.5 C 86 81.9 79.9 88 72.5 88 L 68 88 L 68 96 C 68 97.7 66.7 99 65 99 C 63.3 99 62 97.7 62 96 L 62 64 C 62 62.3 63.3 61 65 61 z M 94 61 C 95.7 61 97 62.3 97 64 L 97 96 C 97 97.7 95.7 99 94 99 C 92.3 99 91 97.7 91 96 L 91 64 C 91 62.3 92.3 61 94 61 z M 68 67 L 68 82 L 72.5 82 C 76.6 82 80 78.6 80 74.5 C 80 70.4 76.6 67 72.5 67 L 68 67 z M 44 68.400391 L 39.800781 85 L 48.199219 85 L 44 68.400391 z"></path> </svg>`, // SVG placeholder
    //         link: { text: "Learn more", href: "/docs/articles/database-to-api", target: "_blank" },
    //       },
    //       {
    //         name: "Chat with Your Database",
    //         description: "Chat with your real-time data in natural language.",
    //         img: `<svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="64" height="64" viewBox="0 0 128 128"> <path d="M 44 1 C 20.3 1 1 20.3 1 44 C 1 67.7 20.3 87 44 87 L 84 87 C 85.2 87 86.300781 86.299219 86.800781 85.199219 C 87.300781 84.099219 86.999219 82.800391 86.199219 81.900391 L 76.599609 72 C 83.299609 64.2 87 54.4 87 44 C 87 20.3 67.7 1 44 1 z M 29 34 L 59 34 C 60.7 34 62 35.3 62 37 C 62 38.7 60.7 40 59 40 L 29 40 C 27.3 40 26 38.7 26 37 C 26 35.3 27.3 34 29 34 z M 95.601562 42.777344 C 94.425 42.894531 93.375 43.700391 93 44.900391 C 92.5 46.500391 93.4 48.199219 95 48.699219 C 110.5 53.499219 121 67.7 121 84 C 121 104.4 104.4 121 84 121 L 51.099609 121 L 57.699219 114.19922 C 58.799219 112.99922 58.799219 111.2 57.699219 110 C 53.599219 105.8 50.499219 100.69961 48.699219 95.099609 C 48.199219 93.499609 46.500391 92.599609 44.900391 93.099609 C 43.300391 93.599609 42.400391 95.300391 42.900391 96.900391 C 44.600391 102.40039 47.500781 107.6 51.300781 112 L 41.800781 121.90039 C 41.000781 122.80039 40.699219 123.99922 41.199219 125.19922 C 41.699219 126.29922 42.8 127 44 127 L 84 127 C 107.7 127 127 107.7 127 84 C 127 65.1 114.90078 48.600391 96.800781 42.900391 C 96.400781 42.775391 95.99375 42.738281 95.601562 42.777344 z M 29 49 L 39 49 C 40.7 49 42 50.3 42 52 C 42 53.7 40.7 55 39 55 L 29 55 C 27.3 55 26 53.7 26 52 C 26 50.3 27.3 49 29 49 z M 55 49 L 59 49 C 60.7 49 62 50.3 62 52 C 62 53.7 60.7 55 59 55 L 55 55 C 53.3 55 52 53.7 52 52 C 52 50.3 53.3 49 55 49 z"></path> </svg>`, // SVG placeholder
    //         link: { text: "Learn more", href: "/docs/articles/chat-with-your-databases", target: "_blank" },
    //       },
    //       {
    //         name: "Publish a Custom GPT",
    //         description: "Share it with your privately users, or make it public.",
    //         img: `<svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="48" height="48" viewBox="0 0 64 64"> <path d="M 29.875 10.625 C 25.861 10.625 22.3 12.922922 20.5 16.294922 L 20.5 29.160156 L 25.501953 32.222656 L 25.685547 19.443359 L 35.931641 12.533203 C 34.185641 11.313203 32.096 10.625 29.875 10.625 z M 40.875 14 C 40.161 14 39.462484 14.095328 38.771484 14.236328 L 28.660156 21.054688 L 28.585938 26.267578 L 38.701172 19.476562 L 51.236328 26.919922 C 51.403328 26.166922 51.5 25.399 51.5 24.625 C 51.5 18.767 46.733 14 40.875 14 z M 17.5 18.974609 C 13.163 20.313609 10 24.354 10 29.125 C 10 30.639 10.320156 32.097734 10.910156 33.427734 L 24.21875 41.005859 L 29.128906 37.962891 L 17.5 30.839844 L 17.5 18.974609 z M 38.798828 23.023438 L 34.857422 25.671875 L 45.916016 32.615234 L 47.314453 45.378906 C 51.116453 43.758906 53.75 40.01 53.75 35.625 C 53.75 34.131 53.432563 32.690187 52.851562 31.367188 L 38.798828 23.023438 z M 32.130859 27.501953 L 28.533203 29.917969 L 28.476562 34.044922 L 31.984375 36.195312 L 35.753906 33.861328 L 35.654297 29.714844 L 32.130859 27.501953 z M 38.701172 31.628906 L 39.019531 45.09375 L 28.107422 51.554688 C 29.989422 53.112687 32.37 54 34.875 54 C 39.17 54 42.887594 51.477625 44.558594 47.765625 L 43.091797 34.384766 L 38.701172 31.628906 z M 35.835938 37.337891 L 24.28125 44.494141 L 13.283203 38.230469 C 13.101203 39.014469 13 39.817 13 40.625 C 13 46.206 17.328734 50.786031 22.802734 51.207031 L 35.978516 43.40625 L 35.835938 37.337891 z"></path> </svg>`, // SVG placeholder
    //         link: { text: "Learn more", href: "/docs/articles/publish-a-custom-gpt-from-your-data", target: "_blank" },
    //       },
    //     ],
    //   },
    // },
    // // Gallery
    // {
    //   gallery: {
    //     style: "carousel",
    //     topText: "Demo",
    //     headline: "See How It Works",
    //     subheadline: "",
    //     items: [
    //       {
    //         type: "video",
    //         title: "Demo",
    //         src: "https://www.loom.com/embed/1e28c89ed4b54085bdaa848bfd3f782e",
    //       },
    //     ],
    //   },
    // },
    // {
    //   gallery: {
    //     style: "carousel",
    //     topText: "API",
    //     headline: "Database to API",
    //     subheadline: "Get (and sync) your data via API.",
    //     items: [
    //       {
    //         type: "image",
    //         title: "Database to API",
    //         src: "https://yahooder.sirv.com/datalang/features/database-to-api.png",
    //       },
    //     ],
    //   },
    // },
    // {
    //   gallery: {
    //     style: "carousel",
    //     topText: "GPT Assistants",
    //     headline: "Chat with your databases",
    //     subheadline: "Create custom GPT Assistants to chat with your data.",
    //     items: [
    //       {
    //         type: "image",
    //         title: "Chat with your databases",
    //         src: "https://yahooder.sirv.com/datalang/features/chat-with-your-databases.png",
    //       },
    //     ],
    //   },
    // },
    // Newsletter
    {
      newsletter: {
        style: "simple",
        headline: t("front.newsletter.title"),
        subheadline: t("front.newsletter.headline"),
      },
    },
    {
      gallery: {
        style: "carousel",
        topText: "ChatGPT",
        headline: "Publish to the GPT Store",
        subheadline: "Configure a GPT to share it with your users, or customers!",
        items: [
          {
            type: "image",
            title: "Create custom GPTs",
            src: "https://yahooder.sirv.com/datalang/features/create-custom-gpts-from-your-data.png",
          },
        ],
      },
    },
    // // Community
    // {
    //   community: {
    //     style: "simple",
    //     headline: "The SaasRock Community",
    //     subheadline: "We're all looking to build successful SaaS applications.",
    //     withName: false,
    //     type: "github",
    //     grid: {
    //       columns: "12",
    //       gap: "sm",
    //     },
    //     cta: [
    //       {
    //         text: "Subscribe",
    //         href: "/pricing",
    //       },
    //       {
    //         text: "Join Discord",
    //         href: "https://discord.gg/KMkjU2BFn9",
    //       },
    //       {
    //         text: "Youtube channel",
    //         href: "https://www.youtube.com/channel/UCdXy3FPDHxP-b7NhPspt6cQ",
    //       },
    //     ],
    //   },
    // },
    // // Testimonials
    // {
    //   testimonials: {
    //     style: "simple",
    //     headline: "Don't take our word for it.",
    //     subheadline: ``,
    //     items: [
    //       {
    //         role: "CEO",
    //         company: "Piloterr",
    //         companyUrl: "https://www.piloterr.com/",
    //         logoLightMode: "https://yahooder.sirv.com/saasrock/testimonials/piloterr-light.png",
    //         logoDarkMode: "https://yahooder.sirv.com/saasrock/testimonials/piloterr-dark.png",
    //         name: "Josselin Liebe",
    //         personalWebsite: "https://josselinlie.be/",
    //         avatar: "https://avatars.githubusercontent.com/u/15314417?v=4",
    //         quote: "You've already solved 90% of my problems with your project :)",
    //       },
    //     ],
    //   },
    // },
    // Faq
    // {
    //   faq: {
    //     style: "simple",
    //     headline: t("front.faq.title"),
    //     subheadline: t("front.faq.subheadline"),
    //     items: defaultFaq({ t }),
    //   },
    // },
    // Footer
    {
      footer: defaultFooter({ t }),
    },
  ];
  return blocks;
}
